import { render, staticRenderFns } from "./ClientCosts.vue?vue&type=template&id=6adf1b6f&scoped=true"
import script from "./ClientCosts.vue?vue&type=script&lang=js"
export * from "./ClientCosts.vue?vue&type=script&lang=js"
import style0 from "./ClientCosts.vue?vue&type=style&index=0&id=6adf1b6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf1b6f",
  null
  
)

export default component.exports